import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HelmetProvider } from 'react-helmet-async';

// Disable browser's automatic scroll restoration to let ScrollToTop work perfectly
if (typeof window !== 'undefined') {
  window.history.scrollRestoration = 'manual';
}

// Auto-recover from stale chunk errors after deployment
window.addEventListener('unhandledrejection', (e) => {
  const err = e.reason;
  if (err?.name === 'ChunkLoadError' || err?.message?.includes('Loading chunk')) {
    e.preventDefault();
    console.warn('Stale chunk detected, reloading...');
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

if (rootElement.hasChildNodes()) {
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

reportWebVitals();